export const INVITE_APP_CONFIGS = {
  default: {
    ANDROID_PACKAGE: 'com.ommnio',
    GOOGLE_PLAY_URL: 'https://play.google.com/store/apps/details?id=com.ommnio',
    APPLE_STORE_URL: 'https://apps.apple.com/es/app/ommnio/id1481362031',
    APP_ID: 'P47KDCH457.com.ommnio.communications.ommnioapp',
    APP_NAME: 'Ommnio',
  },
  'saint-gobain': {
    ANDROID_PACKAGE: 'com.sg.R20B.OmmnioConnectia',
    GOOGLE_PLAY_URL: 'https://play.google.com/store/apps/details?id=com.sg.R20B.OmmnioConnectia',
    APPLE_STORE_URL: 'https://apps.apple.com/app/id6596770709',
    APP_ID: 'ZN75HV5A8E.com.sg.R20B.OmmnioConnectia',
    APP_NAME: 'Connecti@',
  },
};

const isConnectiaAppName = appName => /connecti/i.test(appName || '');

/**
 * Resolve which branded mobile app an invite should open / install.
 * Prefer company branding from the invite API; fall back to hostname for
 * company subdomains (e.g. saint-gobain.web.ommnio.com).
 */
export const resolveInviteAppBrand = ({ hostname = '', company } = {}) => {
  const subDomain = (company?.subDomain || '').toLowerCase();
  const companyName = (company?.name || '').toLowerCase();
  if (
    hostname.toLowerCase().startsWith('saint-gobain') ||
    subDomain === 'saint-gobain' ||
    companyName === 'saint-gobain' ||
    isConnectiaAppName(company?.appName)
  ) {
    return 'saint-gobain';
  }
  return 'default';
};

export const getInviteAppConfig = (opts = {}) =>
  INVITE_APP_CONFIGS[resolveInviteAppBrand(opts)] || INVITE_APP_CONFIGS.default;

/**
 * Build the mobile redirect URL:
 * - Android: custom-scheme intent opens the branded package if installed, else Play Store
 *   (https intents against apex web.ommnio.com don't match Connecti@ App Link filters)
 * - iOS: App Store URL (with custom-scheme campaign param)
 */
export const buildInviteRedirectUrl = ({
  isIOS = false,
  isAndroid = false,
  appConfig,
  token,
  customSchemeURL,
} = {}) => {
  if (!appConfig) {
    return null;
  }
  if (isIOS) {
    return `${appConfig.APPLE_STORE_URL}?ct=${encodeURIComponent(customSchemeURL || '')}`;
  }
  if (isAndroid) {
    const pkg = appConfig.ANDROID_PACKAGE;
    // Prefer ommnio:// so the explicit package can open when installed; https://web.ommnio.com
    // is not covered by Connecti@'s `*.web.ommnio.com` intent filters.
    return `intent://invite?token=${encodeURIComponent(
      token || '',
    )}#Intent;scheme=ommnio;package=${pkg};S.browser_fallback_url=${encodeURIComponent(
      appConfig.GOOGLE_PLAY_URL,
    )};end`;
  }
  return null;
};
